import { useEffect, useState } from 'react';
import { feedbackApi } from '../api/feedbackApi';
import { useAuthStore } from '../stores/auth';
import { useLocalStorage } from './useLocalStorage';

const LAST_PROMPT_KEY = 'lastFeedbackPrompt';
const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

export const useFeedbackPrompt = () => {
  const { isAuthenticated, user } = useAuthStore();
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [lastPromptTime, setLastPromptTime] = useLocalStorage<number | null>(
    LAST_PROMPT_KEY,
    null,
  );

  useEffect(() => {
    const checkAndPromptForFeedback = async () => {
      if (!isAuthenticated || !user?._id) {
        return;
      }

      const now = Date.now();
      const shouldPromptBasedOnTime = !lastPromptTime || (now - lastPromptTime) > ONE_DAY_IN_MS;

      if (shouldPromptBasedOnTime) {
        try {
          const hasSubmittedRecentFeedback = await feedbackApi.checkRecentFeedback();
          if (!hasSubmittedRecentFeedback) {
            setShowFeedbackModal(true);
            setLastPromptTime(now); // Update last prompt time regardless of whether they submit
          }
        } catch (error) {
          console.error('Failed to check recent feedback:', error);
        }
      }
    };

    checkAndPromptForFeedback();
  }, [isAuthenticated, user?._id, lastPromptTime, setLastPromptTime]);

  const handleFeedbackSubmitted = () => {
    // Optionally update local storage or state to prevent immediate re-prompt
    // This is already handled by setLastPromptTime(now) in the effect,
    // but can be useful for more complex logic.
  };

  return {
    showFeedbackModal,
    setShowFeedbackModal,
    handleFeedbackSubmitted,
  };
};